import images from "@assets/images";
import { DimensionContext } from "@src/DimensionProvider";
import React from "react";
import { Image, View } from "react-native";
import GoldCoins from "./gold-coins";
import GoldDropdown from "./gold-dropdown";
import useStyles from "./styles.css";

const GoldBar = () => {
  const styles = useStyles();
  const { baseWidth, hudHeight } = React.useContext(DimensionContext);

  return (
    <View style={[styles.container, { width: baseWidth * 0.1927, height: hudHeight * 0.6197 }]}>
      <View pointerEvents="none" style={styles.goldBar}>
        <Image
          resizeMode="stretch"
          source={{uri: images.gold_bar}}
          style={styles.goldBar}
        />
      </View>
      <GoldCoins baseHeight={hudHeight} />
      <GoldDropdown />
    </View>
  );
};

export default GoldBar;
